import React from 'react';
import { motion } from 'framer-motion';
import { SQUARE_SERVICES_URL } from '../constants/links';
import { useLanguage } from '../i18n/LanguageContext';

const FinalCTA = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-brand-taupe relative overflow-hidden">
      {/* Background Pattern/Texture (Subtle) */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] mix-blend-overlay"></div>
      
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="font-serif text-4xl md:text-5xl text-white mb-6">
            {t('finalCta.title')}
          </h2>
          <p className="text-white/90 text-lg md:text-xl font-light mb-10 max-w-2xl mx-auto">
            {t('finalCta.body')}
          </p>
          <a 
            href={SQUARE_SERVICES_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-block bg-white text-brand-taupe hover:bg-brand-cream px-10 py-4 rounded-full text-lg font-medium transition-all shadow-lg hover:shadow-xl hover:-translate-y-1"
          >
            {t('finalCta.button')}
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
